<template>
  <div>
    <div v-if="
      this.basic.tag === 'U1' ||
      this.basic.tag === 'C1' ||
      this.basic.tag === 'F1'
      ">
      <v-btn :color="ui.btnColor" flat @click="openDialog()"
      v-if="this.data.size === 'flat'"
      :disabled="disableStats">
        <v-icon left :color="ui.btnColor">
          analytics
        </v-icon>
        Open
      </v-btn>
      <v-btn icon @click="openDialog()"
      :disabled="disableStats"
      v-else>
        <v-icon :color="ui.btnColor">
          analytics
        </v-icon>
      </v-btn>
    </div>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon medium left :color="ui.iconColor"> analytics </v-icon>
            <span :class="ui.textTitle">
              {{this.defineDocumentFromTag(data.tag).title}} Stats Open
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row class="text-xs-left ml-4 mr-2" v-if="data.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> pin </v-icon>
              </v-avatar>
              {{displayDocumentIDGTypeA(this.basic.tag, this.basic.idg)}}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.link === true">
              <v-icon> link </v-icon>
            </v-chip>
            <!-- <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.save === true">
              <v-icon :color="ui.btnColorWarning"> save </v-icon>
            </v-chip> -->
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.lock === true">
              <v-icon :color="ui.btnColorWarning"> lock </v-icon>
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2" v-if="data.tag === 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> person </v-icon>
              </v-avatar>
              Approved and Active Tasks
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.lock === true">
              <v-icon :color="ui.btnColorWarning"> lock </v-icon>
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="data.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> title </v-icon>
              </v-avatar>
              {{basic.title}}
            </v-chip>
            <v-spacer/>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="this.basic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> sell </v-icon>
              </v-avatar>
              {{basic.id}}
            </v-chip>
            <v-spacer/>
          </v-layout>
          <!-- BUSINESS / SAFETY  -->
          <v-layout class="mt-3"/>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.ns6o !== undefined && this.basic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{this.defineDocumentFromTag("S6").icon}} </v-icon>
              </v-avatar>
              {{this.defineDocumentFromTag("S6").titles}}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            {{ stats.ns6o }}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.nb3o !== undefined">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{this.defineDocumentFromTag("B3").icon}} </v-icon>
              </v-avatar>
              {{this.defineDocumentFromTag("B3").titles}}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            {{ stats.nb3o }}
            </v-chip>
          </v-layout>
          <!-- BUSINESS / SAFETY  -->
          <v-layout class="mt-3"/>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.nb4o !== undefined && this.basic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{this.defineDocumentFromTag("B4").icon}} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("B4").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nb4o }}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.nb6o !== undefined && this.basic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{ this.defineDocumentFromTag("B6").icon }} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("B6").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nb6o }}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.nq1o !== undefined">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{ this.defineDocumentFromTag("Q1").icon }} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("Q1").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nq1o }}
            </v-chip>
          </v-layout>
          <!-- TECHNICAL / WORK  -->
          <v-layout class="mt-3"/>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.no1o !== undefined">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{ this.defineDocumentFromTag("O1").icon }} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("O1").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.no1o }}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.ne2o !== undefined && this.basic.tag !== 'F1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{ this.defineDocumentFromTag("E2").icon }} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("E2").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            {{ stats.ne2o }}
            </v-chip>
          </v-layout>
          <!-- MAINT  -->
          <v-layout class="mt-3"/>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.nw1o !== undefined">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{ this.defineDocumentFromTag("W1").icon}} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("W1").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nw1o }}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="stats.nw2o !== undefined">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> {{ this.defineDocumentFromTag("W2").icon}} </v-icon>
              </v-avatar>
              {{ this.defineDocumentFromTag("W2").titles }}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            {{ stats.nw2o }}
            </v-chip>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      indeterminateProgressBar: false
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailRev",
      "getDetailBasic",
      "getDetailStats",
      "getDetailRelps",
      "getUser",
      "getUserStats",
      "getCurrentPage"
    ]),
    disableStats() {
      // DO NOT DISPLAY BAD DATA STATS for
      // COMPANY NOR FACILTY
      let logic = false;
      if (this.getCurrentPage === "/companymanagement") {
        if (this.getDetailStats === null) {
          logic = true;
        } else if (this.getDetailStats.n < 1) {
          logic = true;
        } else if (this.getDetailStats.nf1 === undefined) {
          logic = true;
        } else if (this.getDetailStats.dsin !== undefined) {
          logic = true;
        } else {
          logic = false;
        }
      } else if (this.getCurrentPage === "/facilitymanagement") {
        if (this.getDetailStats === null) {
          logic = true;
        } else if (this.getDetailStats.n < 1) {
          logic = true;
        } else if (this.getDetailStats.nf1 !== undefined) {
          logic = true;
        } else if (this.getDetailStats.dsin !== undefined) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    stats() {
      let stats = null;
      if (this.data.tag === "U1") {
        stats = this.getUserStats;
      } else {
        stats = this.getDetailStats;
      }
      return stats;
    },
    basic() {
      let stats = null;
      if (this.data.tag === "U1") {
        stats = this.getUser.basic;
      } else {
        stats = this.getDetailBasic;
      }
      return stats;
    },
    relps() {
      return this.getDetailRelps;
    },
    tag() {
      return this.getDetail.basic.tag;
    },
    dp() {
      let dp = null;
      if (this.getDetail.basic.rdp === "") {
        dp = "Not Signed";
      } else {
        dp = this.getDetail.basic.rdp;
      }
      return dp;
    },
    tc() {
      let tc = null;
      if (this.getDetail.basic.rtc === "") {
        tc = "Not Signed";
      } else {
        tc = this.getDetail.basic.rtc;
      }
      return tc;
    }
  },
  // eslint-disable-next-line
  mixins: [apptheme, dateFunctions, displayFunctions, describeDocument],
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
